








































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { ShopUser } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "UserList",
  mixins: [],
  data(): {
    authentication: object;
    transitionName: string;
    loaded: boolean;
    users: List<ShopUser> | undefined;
    parPage: number;
    currentPage: number;
  } {
    return {
      authentication,
      transitionName: "",
      loaded: false,
      users: undefined,
      parPage: 10,
      currentPage: 1
    };
  },
  async created() {
    this.users = new Collection(
      db.collection("shopUser") as firestore.CollectionReference<ShopUser>
    ).query({
      filter: {
        shopId: { $eq: this.shopId }
      },
      orderBy: {
        field: "createTime",
        order: "desc"
      }
    });
    await this.users.ref.get();
    this.loaded = true;
  },
  computed: {
    listItem(): DocDataRef<ShopUser>[] | [] {
      const current = this.currentPage * this.parPage;
      const start = current - this.parPage;
      return this.users?.items ? this.users.items.slice(start, current) : [];
    },
    getPageCount(): number {
      return this.users?.items
        ? Math.ceil(this.users.items.length / this.parPage)
        : 0;
    },
    total(): number | undefined {
      return this.users?.items?.length;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
    }
  },
  watch: {}
});
